module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-card-content",
    style: (_vm.topBackgroundStyle)
  }, [_c('div', {
    staticClass: "page-card-type -bottom-up",
    style: (_vm.bottomBackgroundStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "page-card-container",
    class: {
      't-birthday': _vm.type === _vm.$const.SPECIAL_EVENT_TYPES.BIRTHDAY
    }
  }, [_c('div', {
    staticClass: "preview-text"
  }, [_c('h3', {
    staticClass: "page--title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "page--owner"
  }, [_c('div', {
    staticClass: "page--owner-name",
    domProps: {
      "innerHTML": _vm._s(_vm.processedName)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page--owner-date",
    domProps: {
      "innerHTML": _vm._s(_vm.processedDate)
    }
  })])])]), _vm._v(" "), (_vm.avatarSrc) ? _c('div', {
    staticClass: "img-circle",
    style: (_vm.AvatarBackgroundStyle)
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b970a228","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/pages/special-events/card-content.vue
// module id = 1214
// module chunks = 0